import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    overflowX: 'hidden',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      height: '100vh',
      marginTop: 80
    }
  },
  boxTable: {
    width: '90%',
    marginLeft: '5%',
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    marginTop: '1rem'
  },
  boxtitle: {
    width: '90%',
    display: 'flex',
    marginLeft: '5%',
    color: '#4B4952',
    paddingTop: '0.5rem'
  },
  title: {
    fontSize: '2em',
    letterSpacing: '0.04rem',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  boxSubTitle: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4952',
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: '5%',
    marginTop: '0.5rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  subtitle: {
    fontSize: '1rem',
    marginLeft: 8,
    fontWeight: 'bold',
    '@media all and (max-width: 600px)': {
      fontSize: '1em'
    }
  },
  message: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    paddingLeft: '1%',
    '@media all and (max-width: 600px)': {
      fontSize: '0.9em'
    }
  },
  messageQuestion: {
    fontSize: '1.3rem',
    fontWeight: 'bold',
    '@media all and (max-width: 600px)': {
      fontSize: '1em'
    }
  },
  buttonVerifyStateMEApp: {
    backgroundColor: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 5,
    marginTop: '2%',
    marginLeft: '5%',
    border: '1px solid #dbdbdb',
    padding: 10,
    maxWidth: '45%',
    borderLeft: '4px solid #00A88F',
    cursor: 'pointer',
    color: '#008471',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.5)'
    }
  }
}))

export default useStyles
